// extracted by mini-css-extract-plugin
export default {"contentContainer":"_2Q172___contentWidth-module__contentContainer","contentPadding":"_2utf8___contentWidth-module__contentPadding"};